import { callRestApi } from '@hooks/useRestApi'

const SERVICE_URLS = {
  productQuestionAnswers: (product_id) =>
    `/product/questions-answer/${product_id}`,
  likeDislikeUrl: (likeDislike, answerID) =>
    `/product/answer-${likeDislike}/${answerID}`,
  writeAnswer: '/product/answer-write',
  addQuestions: '/product/question-write',
}

const getQuestionAnswersData = async (product_id: string) => {
  return callRestApi(SERVICE_URLS.productQuestionAnswers(product_id))
}

const likeDislike = async (like: boolean, answerID: string) => {
  const likeDislike = like ? 'like' : 'dislike'
  return callRestApi(SERVICE_URLS.likeDislikeUrl(likeDislike, answerID))
}

// likeDislike(like,answerID){
//   return new Promise((resolve, reject) => {
//   const likeDislike = like ? 'like' :'dislike';
//   axiosfsd.get(`/product/answer-${likeDislike}/${answerID}`).then(res=>{
//       resolve(res);
//   })
// });
// }

const addAnswer = (data) => {
  return callRestApi(SERVICE_URLS.writeAnswer, 'post', data)
}

// addAnswer(question_id,customer_name,customer_id,position,answer){
//   return new Promise((resolve, reject) => {

//   axiosfsd.post(`/product/answer-write`,{data:{question_id,customer_name,customer_id,position,answer}}).then(res=>{
//       if(window.FsdApp)   window.FsdApp.getController('dialog').notify({text:'Thank you for your answer, it will be reviewed and posted shortly',theme:"success"});
//       resolve(res);
//   })
// });
// }

const addQuestion = async (data) => {
  return callRestApi(SERVICE_URLS.addQuestions, 'post', data)
}

// addQuestion(product_id,position,question,author_name){
//   return new Promise((resolve, reject) => {

//       axiosfsd.post(`/product/question-write`,{data:{product_id,position,question,author_name}}).then(res=>{
//           resolve(res);
//       })
//   });
// }

const pdpQuestionAnswersService = {
  getQuestionAnswersData,
  likeDislike,
  addAnswer,
  addQuestion,
}

export default pdpQuestionAnswersService
